import {PolymerElement} from '@polymer/polymer';
import {ScopeBinding, ScopeRoot} from '../behaviors/keli-binding-behavior';

class KeliChartController extends ScopeRoot(ScopeBinding(PolymerElement)) {
  static get is() {
    return 'keli-chart-controller'
  }

  static get properties() {
    return {
      dataLoaded: {type: Boolean, value: false},
      element: {type: Object},
      manualKeliReady: {type: Boolean, value: true}
    }
  }

  constructor() {
    super();
    this.addOnKeli({'uireloaddata': 'handleReloadData'});
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.element = null;
  }

  async elementReady(element) {
    this.element = element;
    if (!this.element.keliname) {
      return;
    }

    await this.changeKeliScopeRootName(this.element.keliname);
    await this.keliReady(this.element.getKeliScope());

    this.executeOnKeliReadyComplete(async () => {
      if (!this.isConnected) return;
      await this.runKeliFunction('uiSet', 'mode', 'chart');
      this.loadData();
    });
  }

  async handleReloadData(event, templateInstance) {
    if (!this.dataLoaded) {
      return;
    }
    await this.loadData(templateInstance);
  }

  async loadData(templateInstance) {
    if (!this.element.keliname) {
      return;
    }
    templateInstance = this.getKeliTemplateInstance(templateInstance);
    let chartData = await this.runKeliFunctionIn(templateInstance, 'rowsGetPreloaded');
    if (!this.isConnected) return;
    if (chartData && chartData.rows && Array.isArray(chartData.rows)) {
      chartData = chartData.rows;
    }
    if (!chartData) {
      chartData = await this.runKeliFunctionIn(templateInstance, 'rowsGet', {asarray: true});
      if (!this.isConnected) return;
    }
    this.element.chartData = chartData;

    if (!this.dataLoaded) {
      this.dataLoaded = true;
      this.dispatchEvent(new CustomEvent('dataLoaded', {
        bubbles: true,
        composed: true,
        detail: {element: this.element}
      }));
    }
  }
}

customElements.define(KeliChartController.is, KeliChartController);
export {KeliChartController};
